<!--
  - PortUNA Framework (http://www.portuna.de/)
  -
  - @author     Grandke, Luke <grandke@portuna.de>
  - @copyright  PortUNA Neue Medien GmbH (http://www.portuna.de)
  - @created    3.6.2025 13:48 Uhr
  -->

<template>
    <div>
        <div class="padding-left-45">
            <p v-if="props.text">{{text}}</p>
            <br>
            <form-row-static label="Festgesetzt">
                von {{dateHelper('d.m.Y', props.freezeEnd.date_start)}} bis {{dateHelper('d.m.Y', props.freezeEnd.date)}}
            </form-row-static>
            <form-row-static label="Festgesetzt von">
                <person-box-user :id="props.freezeEnd.creator">
                    am {{dateHelper('d.m.Y, H:i:s', props.freezeEnd.created)}}
                </person-box-user>
            </form-row-static>
        </div>
    </div>
</template>

<script setup lang="ts">
    import FormRowStatic from '@/components/form/FormRowStatic.vue';
    import PersonBoxUser from '@/components/PersonBoxUser.vue';
    import dateHelper from '@/utils/portuna/dateHelper';

    const props = defineProps<{
        freezeEnd: IOvertimeFreeze;
        text: string;
    }>();
</script>